'use strict';

import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './auth.routes.js';
import forgotpassword from './forgotpassword/index.js';
import login from './login/index.js';
import setpassword from './setpassword/index.js';

export default angular.module('georgeApp.account',
  [uiRouter, forgotpassword, login, setpassword])
  .config(routing)
  // .run(function($rootScope) {
  //   $rootScope.$on('$stateChangeStart',
  //   function(event, next, nextParams, current) {
  //     if(next.name === 'logout' && current
  //     && current.name && !current.authenticate) {
  //       next.referrer = current.name;
  //     }
  //   });
  // })
  .name;
